import { BodyVariant, SizeOptions } from '../../../../types/types'

export const sizeStyles: Record<SizeOptions, string> = {
    small: '!min-h-5', // 20px
    medium: '!min-h-7', // 28px
    large: '!min-h-9', // 36px
}

export const typographyStyles: Record<SizeOptions, BodyVariant> = {
    small: 'body-small',
    medium: 'body',
    large: 'body',
}

type ControlState = { isDisabled?: boolean; readOnly?: boolean; error?: boolean; menuIsOpen: boolean; isFocused: boolean }

// Only hovering eases the border in, as in AstraInputWrapper: opening, focus and errors change instantly. react-select
// sets `transition: all` on the control, hence the `!`; callers add `!transition-none` to the control.
const hoverTransitionStyles = 'hover:!transition-[border-color] hover:!duration-150 hover:!ease-out'

/**
 * The field's border, halo and background in each state, shared by AstraSelect and AstraMultiSelect so the two read
 * as one component. One border and one background per state, with the tokens of AstraInputWrapper's frame. Two color utilities on the
 * same property resolve by their order in the generated stylesheet, not by their order in the class list, so the
 * states can't be layered as overrides.
 *
 * The 2px halo is the frame's flush outline, drawn as a ring because react-select forces `outline: 0 !important` on
 * the control. An error keeps its critical border while open, so it stays visible while the user corrects it.
 */
export const selectControlStateStyles = ({ isDisabled, readOnly, error, menuIsOpen, isFocused }: ControlState) => {
    if (isDisabled) return 'border-disabled bg-surface-disabled text-disabled'
    if (readOnly) return 'border-base bg-surface-muted text-muted'
    if (error) return `border-critical-strong bg-surface-base ring-2 ring-critical-subtle hover:border-critical-base ${hoverTransitionStyles}`
    if (menuIsOpen) return 'border-focus bg-surface-base ring-2 ring-brand-subtle'
    if (isFocused) return 'border-ring bg-surface-base ring-2 ring-brand-subtle'
    return `border-base bg-surface-base hover:border-hover ${hoverTransitionStyles}`
}
